// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"primary-button-module--primary-button--2nV-n","disabled":"primary-button-module--disabled--3u_Ha"};